import axios from 'axios';
import config from '../config';

export const getActivationSticksBundleUpdateStatus = (deviceId: string) => {
    return axios.get(`${config.API_URL}/onboard-devices/${deviceId}/sticks/bundle`).then((response: any) => {
        return response.data;
    });
};
